import {
  StyleSheet,
} from 'react-native';

import {
  primaryFont300,
  primaryFont500,
  primaryColor,
} from '../Common';

export default StyleSheet.create({
  panel_hover: {
    backgroundColor: '#e0e0e0',
    // cursor: 'pointer',
  },
  panel: {
    borderRadius: 8,
    flex: 1,
    flexDirection: 'row',
    height: 128,
    minHeight: 128,
    maxHeight: 128,
    shadowColor: '#BEBDBD',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.3,
    shadowRadius: 50,
    elevation: 8,
    margin: 20,
    marginBottom: 0,
  },
  panelPromoted: {
    borderRadius: 8,
    flex: 1,
    flexDirection: 'row',
    height: 128,
    minHeight: 128,
    maxHeight: 128,
    shadowColor: '#BEBDBD',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.3,
    shadowRadius: 50,
    elevation: 8,
    margin: 10,
    marginBottom: 0,
  },
  panelInner: {
    backgroundColor: 'white',
    flex: 1,
    flexDirection: 'column',
    minHeight: 128,
    maxHeight: 128,
    height: 128,
    justifyContent: 'space-around',
    padding: 12,
    overflow: 'hidden',
    borderBottomLeftRadius: 8,
    borderTopLeftRadius: 8,
  },
  panelRating: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingVertical: 6,
    overflow: 'hidden',

    // borderWidth: 1,
    // borderColor: 'red',
  },
  panelBottom: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    // borderWidth: 1,
    // borderColor: 'blue',
  },
  imageBlockBackground: {
    backgroundColor: '#e0e0e0',
    borderRadius: 8,
    overflow: 'hidden',
    width: 128,
    minHeight: 128,
    height: 128,
    margin: 0,
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageBlock: {
    borderRadius: 8,
    // justifyContent: 'flex-start',
    width: 128,
    minHeight: 128,
    height: 128,
    // minHeight: 64,
    // minWidth: 64,
    // backgroundColor: '#e0e0e0',
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    // backgroundClip: 'content-box',
    // borderWidth: 1, // px
    // borderStyle: 'solid',
    // borderColor: 'grey',
    margin: 0,
    padding: 0,
    // resizeMode: 'cover',
    // resizeMode: 'center',
    overflow: 'hidden',
  },
  imageBlockNone: {
    borderRadius: 8,
    justifyContent: 'flex-start',
    width: 64,
    minHeight: 64,
    height: 64,
    // minHeight: 64,
    // minWidth: 64,
    // backgroundColor: '#e0e0e0',
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    // backgroundClip: 'content-box',
    // borderWidth: 1, // px
    // borderStyle: 'solid',
    // borderColor: 'grey',
    margin: 0,
    padding: 0,
    // resizeMode: 'cover',
    // resizeMode: 'contain',
    // transform: [
    //   { scale: 0.5 },
    // ],
    overflow: 'hidden',
  },
  image_img: {
    maxWidth: '100%',
    height: 'auto',
  },
  name: {
    // whiteSpace: 'nowrap',
    fontSize: 14,
    fontFamily: primaryFont500,
    fontWeight: '500',
    lineHeight: 17,
    maxWidth: '100%',
    overflow: 'hidden',
    marginBottom: 5,
  },
  namePromoted: {
    // whiteSpace: 'nowrap',
    fontSize: 14,
    fontFamily: primaryFont500,
    fontWeight: '500',
    lineHeight: 17,
    maxWidth: '100%',
    overflow: 'hidden',
    marginBottom: 5,
    color: 'teal',
  },
  description: {
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
    overflow: 'hidden',
    flex: 1,
    // marginBottom: 2,
  },
  descriptionPromoted: {
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
    overflow: 'hidden',
    flex: 1,
    // marginBottom: 5,
    color: 'teal',
  },
  rating: {
    // flex: 1,
    flexShrink: 1,
    // flexGrow: 0,
    alignSelf: 'flex-start',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
  },
  reviews: {
    // flex: 1,
    paddingLeft: 10,
    textAlignVertical: 'center',
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
  },
  durationImage: {
    marginTop: 8,
    marginRight: 2,
    maxHeight: 12,
    height: 12,
    width: 12,
    resizeMode: 'contain',
  },
  duration: {
    // marginTop: 8,
    marginRight: 13,
    marginLeft: 1,
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
    textAlignVertical: 'center',
    alignSelf: 'center',
  },
  priceImage: {
    // marginTop: 8,
    // marginLeft: 10,
    maxHeight: 14,
    height: 14,
    width: 18,
    // resizeMode: 'contain',
  },
  price: {
    // marginTop: 8,
    flex: 1.0,
    // marginLeft: 10,
    marginLeft: 1,
    overflow: 'hidden',
    flexWrap: 'nowrap',
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
    textAlignVertical: 'center',
    alignSelf: 'center',
  },
  tag: {
    // marginTop: 8,
    // flex: 0.3,
    marginLeft: 5,
    marginRight: 5,
    overflow: 'hidden',
    flexWrap: 'nowrap',
    fontSize: 12,
    fontFamily: primaryFont300,
    fontWeight: '300',
    lineHeight: 13,
    textAlignVertical: 'right',
    alignSelf: 'center',
    color: primaryColor,
    textDecorationLine: 'underline',
  },
});
